import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr2031',
    ecrans: ['00-2'],
    params: ['pamcleint']
});
